import React, { useState, useEffect } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { Player, BigPlayButton } from 'video-react';
import 'video-react/dist/video-react.css'; // Importa los estilos CSS


/**
* listado de props requeridas
* @param titulo titulo modal
* @param msjModal array con el contenido a mostrar.
* @param setMsjModal setMsjModal() es la funcion modificadora de msjModal, y su proposito es ser seteado limpiado una vez se visualice y cierre modal
* @param color_caja color header de caja modal
* * bg-primary(azul), bg-secondary(gris), bg-success(verde), bg-danger(rojo), bg-warning(amarillo), bg-info(celeste), bg-light(blanco), bg-dark(negro)
* @param color_letra text-white(blanco), text-dark(negro)
*/
function ModalVideos(props) {


  const [verModal, setverModal] = useState(false);



  const desplegarModal = () => setverModal(true);
  
  const cerrarModal = () => {
    props.setVideo('');
    setverModal(false);
 
  };

  


  useEffect(() => {
    desplegarModal(true);
  }, []);  




  return (
    <>
      <Modal 
      fullscreen={true}      
      scrollable={true}
      show={verModal} 
      onHide={cerrarModal}
      >
        <Modal.Header closeButton className={'bg-secondary text-white'}>
          <Modal.Title >{props.titulo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>


          <section>
            <Player 
              src={`/vid/${props.video}`}
            >
            <BigPlayButton position="center" />
          </Player>
          </section>


        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={cerrarModal}>Cerrar</Button>
        </Modal.Footer>
        
      </Modal>
    </>
  );
}


export { ModalVideos };


